// Media break-pair linking constraints
// For each user U and consecutive same-day event pair (Ei -> Ej),
// define p_{U,Ei,Ej} to indicate U works both events. Linearization via sums over roles:
// Let y1 = sum_R x_{U,Ei,R}, y2 = sum_R x_{U,Ej,R}. With within-event uniqueness, y1,y2 in {0,1}.
// Constraints:
//   1) p - y1 <= 0
//   2) p - y2 <= 0
//   3) -p + y1 + y2 <= 1
// Requires indexes: staffRequiredByRole, decisionVariables, adjacencyEdges, adjacencyPairDecisionVariables, users
export function buildMediaBreakPairsConstraints(model, _params = {}) {
  const idx = model?.optimizationIndexes || {};
  const byRole = idx.staffRequiredByRole || {};
  const declaredX = new Set(Object.keys(idx.decisionVariables || {}));
  const declaredP = new Set(Object.keys(idx.adjacencyPairDecisionVariables || {}));
  const edges = Array.isArray(idx.adjacencyEdges) ? idx.adjacencyEdges : [];
  const users = Object.keys(idx.users || {});

  const constraints = [];

  for (const edge of edges) {
    const a = edge?.a;
    const b = edge?.b;
    if (!a || !b) continue;
    const rolesA = Object.keys(byRole[a] || {});
    const rolesB = Object.keys(byRole[b] || {});
    for (const uKey of users) {
      const pName = `p_${uKey}_${a}_${b}`;
      if (!declaredP.has(pName)) continue;
      const xA = rolesA.map((r) => `x_${uKey}_${a}_${r}`).filter((n) => declaredX.has(n));
      const xB = rolesB.map((r) => `x_${uKey}_${b}_${r}`).filter((n) => declaredX.has(n));
      // 1) p - sum xA <= 0
      if (xA.length) {
        constraints.push({ linear: { vars: [pName, ...xA], coeffs: [1, ...xA.map(() => -1)] }, domain: [-100000, 0] });
      } else {
        // If no assignment vars exist on A for this user, then p must be 0 via (3) below.
      }
      // 2) p - sum xB <= 0
      if (xB.length) {
        constraints.push({ linear: { vars: [pName, ...xB], coeffs: [1, ...xB.map(() => -1)] }, domain: [-100000, 0] });
      }
      // 3) -p + sum xA + sum xB <= 1
      const vars3 = [pName, ...xA, ...xB];
      const coeffs3 = [-1, ...xA.map(() => 1), ...xB.map(() => 1)];
      constraints.push({ linear: { vars: vars3, coeffs: coeffs3 }, domain: [-100000, 1] });
    }
  }

  return constraints;
}

